import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { getBirthdayMessage } from '@hapana/shared/utils/date.util'
import AlertSection from '../alert-section/alert-section.component'

const BirthdayAlert = ({ birthday }) => {
  const { t } = useTranslation('checkIn')
  const { t: alertsT } = useTranslation('alerts')
  const month = birthday?.split?.('-')[1]
  const day = birthday?.split?.('-')?.[2]?.split?.('T')[0]

  const birthdayResult = getBirthdayMessage(`${day}/${month}`, alertsT)
  if (!birthdayResult) {
    return null
  }

  const description = `${birthdayResult.message} • ${birthdayResult.formatted}`

  return <AlertSection type="birthday" title={t('birthday')} description={description} />
}

BirthdayAlert.propTypes = {
  birthday: PropTypes.string.isRequired,
}

export default BirthdayAlert
